"use client";

import { c as _c } from "react/compiler-runtime";
import { Check } from "lucide-react";
import { SCHEDULING_STEPS, STEP_LABELS, type SchedulingStepId } from "@/src/components/online-scheduling/types";
import { cn } from "@/src/lib/shadcn-utils";
export function ProgressSteps(t0) {
  const $ = _c(10);
  const {
    current
  } = t0;
  const currentIndex = SCHEDULING_STEPS.indexOf(current);
  const t1 = currentIndex + 1;
  const t2 = STEP_LABELS[current];
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <p className="mb-4 text-center text-sm font-medium text-muted-foreground sm:hidden">Step {t1} of {SCHEDULING_STEPS.length} · {t2}</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== currentIndex) {
    t4 = SCHEDULING_STEPS.map((step, index) => {
      const isComplete = index < currentIndex;
      const isCurrent = index === currentIndex;
      return <li key={step} className={cn("flex items-center", index < SCHEDULING_STEPS.length - 1 && "flex-1")}><div className="flex items-center gap-2"><span className={cn("flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition-colors", isComplete && "border-foreground bg-foreground text-background", isCurrent && "border-foreground text-foreground", !isComplete && !isCurrent && "border-border text-muted-foreground")}>{isComplete ? <Check className="h-4 w-4" /> : index + 1}</span><span className={cn("whitespace-nowrap text-sm", isCurrent ? "font-semibold text-foreground" : "text-muted-foreground")}>{STEP_LABELS[step]}</span></div>{index < SCHEDULING_STEPS.length - 1 && <div className={cn("mx-2 h-px flex-1", isComplete ? "bg-foreground" : "bg-border")} />}</li>;
    });
    $[3] = currentIndex;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <ol className="hidden items-center sm:flex">{t4}</ol>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <nav aria-label="Progress" className="w-full">{t3}{t5}</nav>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}